// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { windowText16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-window-text': IconWindowText;
    }
}

/**
 * The icon component for the 'windowText' icon
 */
export class IconWindowText extends IconSvg {
    public constructor() {
        super(windowText16X16);
    }
}

registerIconSvg('icon-window-text', IconWindowText);
export const iconWindowTextTag = 'nimble-icon-window-text';
